// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","employerHistoryRow":"_3TELmn7WK_Km9gITQUk0kf","employerHistoryColumn":"_2BCS1eAsS0go_BYshRDOMU","employerHistoryCurrentEmployer":"_3hpAbGJO-y1Pjn7YN5HX8K"};